// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5508":"491d94a0d8c02c6c","6227":"b6dd07c8529004ce"}[chunkId] + ".css";
};